var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168311",
    transform: "translate(0 -249.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_291",
    d: "M85,292.1a42.5,42.5,0,1,1-42.5-42.5A42.464,42.464,0,0,1,85,292.1Z",
    fill: "#ee4492"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_108806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157055",
    d: "M53.6,277.1a1.567,1.567,0,0,0-.3-.4.887.887,0,0,0-.4-.1.407.407,0,0,0-.3.1,1.567,1.567,0,0,0-.3.4l-3.7,11.3h8.7ZM27.5,288.5l-1.9,5.7a.85.85,0,0,0,0,.8l.2.4.3.3,16.3,11.9L27.5,288.5Zm8.7,0-3.7-11.4a.654.654,0,0,0-.3-.3.887.887,0,0,0-.4-.1.407.407,0,0,0-.3.1.654.654,0,0,0-.3.3l-3.7,11.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157056",
    d: "M36.2,288.4l6.2,19.2,6.2-19.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157057",
    d: "M59.2,294.2l-1.9-5.8L42.4,307.6l16.3-12a.654.654,0,0,0,.3-.3l.2-.4a.767.767,0,0,1,.1-.3.579.579,0,0,0-.1-.4Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile3);
export default __webpack_public_path__ + "static/media/file3.dfa4e761ebe332518e3f64a76c859e7b.svg";
export { ForwardRef as ReactComponent };